<template>
  <Layout>
    <div class="d-flex flex-wrap">
      <!--<div
        class="card overflow-auto"
        style="width: 300px; flex: 0 0 auto; max-height: 80vh"
      >
        <equipSearchTree></equipSearchTree>
      </div> -->
      <div style="flex: 0 0 auto; width: calc(100%)">
        <div class="d-flex flex-wrap">
          <i
            class="ri-arrow-left-s-line fs-36 text-primary"
            style="width: 30px; flex: 0 0 auto"
            @click="goBack"
          ></i>
          <div style="flex: 0 0 auto; width: calc(100% - 30px)">
            <div class="d-flex mb-2">
              <div class="flex-1">
                <div class="d-flex justify-content-between">
                  <div class="d-flex align-items-center align-items-center">
                    <h4 class="mt-3 me-3">
                      {{ dataInfo.name }} {{ dataInfo.devicenumber }}
                    </h4>
                    <div class="d-flex align-items-center mt-1">
                      <!-- :class="`status-icon status-icon-${devicestatus}`" -->
                      <span
                        :class="`status-icon status-icon-${devicestatus}`"
                        style="
                          padding: 8px 15px;
                          width: 25px;
                          height: 25px;
                          background-size: 25px 25px;
                        "
                      ></span>
                      <span :class="`badge-${devicestatus} fs-16`">{{
                        status[devicestatus]
                      }}</span>
                    </div>
                  </div>

                  <button
                    v-if="$route.query.index"
                    class="btn btn-info h-50 me-2"
                    type="button"
                    @click="
                      () => {
                        if ($route.query.sub_id) {
                          $router.push(
                            '/VSD420-OverAll?index=' +
                              $route.query.index +
                              '&equip_id=' +
                              $route.query.equip_id +
                              '&sub_id=' +
                              $route.query.sub_id
                          );
                        } else {
                          $router.push(
                            '/VSD420-OverAll?index=' +
                              $route.query.index +
                              '&equip_id=' +
                              $route.query.equip_id
                          );
                        }
                      }
                    "
                  >
                    {{ $t("digital_twin") }}
                  </button>
                </div>
                <div
                  v-if="user && user.user_type !== 'customer'"
                  class="d-flex align-items-center"
                >
                  <div class="mb-3 mt-3">
                    {{
                      `${this.$t(
                        "menu.equipment-management.EquipmentAssetCoding"
                      )}:`
                    }}{{ dataInfo.devicecode || this.$t("page.no") }}
                  </div>
                  <div class="d-flex align-items-center ms-3">
                    <span
                      v-if="dataInfo.is_qrcode_bind"
                      class="badge badge-soft-success fs-11"
                      >{{ this.$t("menu.equipment-management.Bound") }}</span
                    >
                    <span v-else class="badge badge-soft-primary fs-11">{{
                      this.$t("menu.equipment-management.NotBound")
                    }}</span>
                  </div>
                </div>
              </div>
              <div
                v-if="user && user.user_type !== 'customer'"
                style="width: 100px"
              >
                <div style="height: 100px">
                  <vue-qr
                    v-if="qrCodeValue"
                    ref="qrcode"
                    :text="qrCodeValue + ' '"
                    :logo-src="qrcodeLogo"
                    :size="100"
                    :margin="10"
                    :logoMargin="2"
                    :backgroundColor="'#fff'"
                  ></vue-qr>
                </div>
                <button
                  class="btn btn-primary btn-export"
                  @click="exportDeviceQRCode"
                >
                  <i class="ri-download-2-line align-bottom me-1"></i>
                  {{ this.$t("menu.equipment-management.QrcodeExport") }}
                </button>
              </div>
            </div>

            <div class="card">
              <div class="card-header me-2 ms-2">
                <ul
                  class="nav nav-tabs-custom rounded card-header-tabs nav-justified border-bottom-0 mx-n3"
                  role="tablist"
                >
                  <template v-for="(tab, i) in tabsLists" :key="i">
                    <li
                      class="nav-item"
                      v-perm="tab.permCode"
                      v-if="tab.isShow"
                    >
                      <a
                        :class="[
                          'nav-link',
                          tabActive == tab.href && 'active',
                          tab.disabled && 'disabled',
                          'fs-16',
                        ]"
                        :style="{
                          cursor: 'pointer',
                          color:
                            tabActive == tab.href
                              ? '#6691E7'
                              : tab.disabled
                              ? ''
                              : '#495057',
                        }"
                        data-bs-toggle="tab"
                        @click="tabActive = tab.href"
                        role="tab"
                      >
                        {{ tab.title }}
                      </a>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
            <div
              id="tabBox"
              class="tab-content text-muted"
              style="height: 100%"
            >
              <div
                :class="['tab-pane', tabActive == 'baseInfo' && 'active']"
                id="baseInfo"
                role="tabpanel"
              >
                <div class="row gx-3">
                  <div class="col-8">
                    <!-- 设备出厂信息 -->
                    <div
                      class="card"
                      v-for="(Item, I) in equipmanageInfo"
                      v-show="
                        (Item.group !== '商务信息' &&
                          user &&
                          user.user_type === 'customer') ||
                        (user && user.user_type !== 'customer')
                      "
                      :key="I"
                    >
                      <div
                        class="card-header align-items-center d-flex"
                        style="border-bottom-style: dashed"
                      >
                        <h4 class="card-title mb-0 flex-grow-1">
                          {{ $t(Item.group) }}
                        </h4>
                      </div>
                      <div
                        :class="[
                          'card-body',
                          Item.list.length <= 4 &&
                            files.document.length &&
                            'box-pend',
                        ]"
                        style="padding-top: 1.5rem"
                      >
                        <div class="center-ads-list">
                          <div
                            class="li"
                            v-for="(item, i) in Item.list"
                            :key="i"
                          >
                            <div>{{ $t(item.name) }}</div>
                            <div
                              v-if="
                                ['发货时间', '质保到期时间'].includes(item.name)
                              "
                              class="text-body mt-1"
                            >
                              {{
                                formatDatetime(item.value, "YYYY/MM/DD") ||
                                this.$t("page.no")
                              }}
                            </div>
                            <div
                              v-else-if="
                                [
                                  '设备状态',
                                  '应用行业',
                                  '客户属性',
                                  '客户行业',
                                ].includes(item.name)
                              "
                              class="text-body mt-1"
                            >
                              {{
                                item.value ? $t(item.value) : this.$t("page.no")
                              }}
                            </div>
                            <div v-else class="text-body mt-1">
                              {{ item.value || this.$t("page.no") }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 文档 -->
                    <div class="card">
                      <div
                        class="card-header align-items-center d-flex"
                        style="border-bottom-style: dashed; position: relative"
                      >
                        <h4 class="card-title mb-0 flex-grow-1">
                          {{
                            this.$t("menu.equipment-management.DocumentType")
                          }}
                        </h4>
                        <div
                          class="search-box"
                          style="position: absolute; right: 1rem"
                        >
                          <input
                            type="text"
                            class="form-control search"
                            :placeholder="
                              this.$t(
                                'menu.equipment-management.SearchDocumentName'
                              )
                            "
                            v-model="documentKeywords"
                            @keydown="handleSearch"
                          />
                          <i class="ri-search-line search-icon"></i>
                        </div>
                      </div>
                      <div class="card-body">
                        <div
                          class="product-img-slider sticky-side-div ps-5 pe-5"
                          v-if="files.document.length"
                        >
                          <SwiperTool
                            :swiperInfo="{
                              type: 'document',
                              page: 'equipdetail',
                              spaceBetween: 10,
                              slidesPerView: 5,
                              actionsClass: [
                                {
                                  name: 'ri-eye-fill',
                                  action: 'view',
                                  me: 'me-1',
                                },
                                {
                                  name: 'ri-download-2-fill',
                                  action: 'download',
                                  me: 'me-1',
                                },
                              ],
                            }"
                            :list="files.document"
                          >
                          </SwiperTool>
                        </div>
                        <div v-else class="text-center">
                          {{
                            this.$t(
                              "menu.equipment-management.NoFileHasBeenUploaded"
                            )
                          }}
                        </div>
                      </div>
                    </div>
                    <!-- 文档 -->
                  </div>
                  <div
                    class="col-4"
                    style="
                      display: flex;
                      align-items: flex-start;
                      flex-wrap: wrap;
                    "
                  >
                    <div class="card bg-transparent shadow-none w-100 h-100">
                      <div
                        v-if="[...files.image, ...files.video].length"
                        class="w-100"
                      >
                        <div
                          class="product-img-slider sticky-side-div ps-5 pe-5 h-100"
                        >
                          <SwiperTool
                            :swiperInfo="{
                              type: 'imagevideo',
                              page: 'equipdetail',
                              spaceBetween: 0,
                              slidesPerView: 1,
                              actionsClass: [
                                {
                                  name: 'ri-eye-fill',
                                  action: 'view',
                                  fs: 'fs-36',
                                  me: 'me-2',
                                },
                                {
                                  name: 'ri-download-2-fill',
                                  action: 'download',
                                  fs: 'fs-36',
                                  me: 'me-2',
                                },
                                {
                                  name: 'ri-heart-fill',
                                  action: 'collect',
                                  fs: 'fs-36',
                                  me: 'me-2',
                                },
                              ],
                            }"
                            :list="[...files.image, ...files.video]"
                          >
                          </SwiperTool>
                        </div>
                      </div>
                      <div
                        v-else
                        class="w-100 h-50 d-flex flex-column align-items-center justify-content-center noimage text-body fs-24"
                      >
                        <div class="mt-5">
                          {{
                            this.$t(
                              "menu.equipment-management.NoPictureVideoHasBeenUploaded"
                            )
                          }}
                        </div>
                      </div>
                      <div style="width: 100%; height: 45%" class="m-3">
                        <div
                          style="width: 100%; height: 100%"
                          class="mapBox"
                          id="mapBox"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                :class="['tab-pane', tabActive == 'repairInfo' && 'active']"
                id="repairInfo"
                role="tabpanel"
              >
                <EquipmentMaintenance
                  v-if="tabActive == 'repairInfo'"
                  :equipmentList="equipmentList"
                  :itemsList="itemsList"
                ></EquipmentMaintenance>
              </div>
              <div
                :class="['tab-pane', tabActive == 'fullLifecycle' && 'active']"
                id="fullLifecycle"
                role="tabpanel"
              >
                <Timeline
                  v-if="tabActive == 'fullLifecycle'"
                  :instance-id="queryId || equip_id"
                  :instance-info="dataInfo"
                />
              </div>
              <!--     关联机组设备         -->
              <div
                :class="[
                  'tab-pane',
                  tabActive == 'associatedUnitDevices' && 'active',
                ]"
                id="associatedUnitDevices"
                role="tabpanel"
              >
                <div class="card-body bg-white pt-4">
                  <div class="position-relative">
                    <div
                      :class="[
                        'table-responsive',
                        'mb-1',
                        'table-page-responsive',
                        'table-ellipsis',
                      ]"
                    >
                      <child-list-table
                        :column="
                          childListParam.column.filter(
                            (i) => i.dataIndex !== 'root_sn'
                          )
                        "
                        :tableData="childListParam.tableData1"
                        :actionIcon="childListParam.actionIcon"
                        :refreshData="getAssociatedDevices"
                        :show-checkbox="false"
                        :product-type="2"
                        :key="`unit-${dataInfo.id}`"
                        source="equipment-detail-associated"
                        v-model:singleData="singleData"
                        :qrcodeOptions="qrcodeOptions"
                      ></child-list-table>
                      <!--                    <table-loading :count="childListParam.tableData.length" :table-loading="isLoading" :table-loaded="!isLoading"></table-loading>-->
                    </div>
                    <!--                  <div :class="[isLoading && 'visually-hidden']">-->
                    <!--                    &lt;!&ndash; paginate-part&ndash;&gt;-->
                    <!--                    <Pagination-->
                    <!--                      v-if="childListParam.tableData.length"-->
                    <!--                      class="me-3"-->
                    <!--                      v-model:page="page"-->
                    <!--                      v-model:perPage="perPage"-->
                    <!--                      :pages="pages"-->
                    <!--                      :prePageOption="prePageOption"-->
                    <!--                      :tab_info_length="data_length"-->
                    <!--                    ></Pagination>-->
                    <!--                  </div>-->
                  </div>
                </div>
              </div>
              <!--      关联单体设备        -->
              <div
                :class="[
                  'tab-pane',
                  tabActive == 'associatedSingleDevices' && 'active',
                ]"
                id="associatedSingleUnitDevices"
                role="tabpanel"
              >
                <div class="card-body bg-white pt-4">
                  <div class="position-relative">
                    <div
                      :class="[
                        'table-responsive',
                        'mb-1',
                        'table-page-responsive',
                        'table-ellipsis',
                      ]"
                    >
                      <child-list-table
                        :column="
                          childListParam.column.filter(
                            (i) => i.dataIndex !== 'group_sn'
                          )
                        "
                        :tableData="childListParam.tableData"
                        :actionIcon="childListParam.actionIcon"
                        :refreshData="getAssociatedDevices"
                        :show-checkbox="false"
                        :product-type="1"
                        :key="`unit-${dataInfo.id}`"
                        source="equipment-detail-associated"
                        v-model:singleData="singleData"
                        :qrcodeOptions="qrcodeOptions"
                      ></child-list-table>
                      <!--                    <table-loading :count="childListParam.tableData.length" :table-loading="isLoading" :table-loaded="!isLoading"></table-loading>-->
                    </div>
                    <!--                  <div :class="[isLoading && 'visually-hidden']">-->
                    <!--                    &lt;!&ndash; paginate-part&ndash;&gt;-->
                    <!--                    <Pagination-->
                    <!--                      v-if="childListParam.tableData.length"-->
                    <!--                      class="me-3"-->
                    <!--                      v-model:page="page"-->
                    <!--                      v-model:perPage="perPage"-->
                    <!--                      :pages="pages"-->
                    <!--                      :prePageOption="prePageOption"-->
                    <!--                      :tab_info_length="data_length"-->
                    <!--                    ></Pagination>-->
                    <!--                  </div>-->
                  </div>
                </div>
              </div>
              <!--体检报告-->
              <div
                :class="[
                  'w-100',
                  'tab-pane',
                  tabActive == 'examinationReport' && 'active',
                ]"
                id="examinationReportDevices"
                role="tabpanel"
              >
                <examinationReport
                  v-if="examinationWidth"
                  :examinationWidth="examinationWidth"
                  :equip_data="equip_data"
                ></examinationReport>
              </div>
              <div
                :class="[
                  'w-100',
                  'tab-pane',
                  tabActive == 'energyConsumptionAnalysis' && 'active',
                ]"
                id="energyConsumptionAnalysis"
                role="tabpanel"
                style="height: 100%"
              >
                <!-- 能耗分析 -->
                <EnergyConsumptionAnalysis
                  :dataInfo="dataInfo"
                  v-if="tabActive == 'energyConsumptionAnalysis'"
                ></EnergyConsumptionAnalysis>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
  <message-alert :alertInfo="alertInfo" v-if="isShowAlert"></message-alert>
</template>

<script>
import AMapLoader from "@amap/amap-jsapi-loader";
import Layout from "@/layouts/main.vue";
import appConfig from "../../../app.config";
// import equipSearchTree from "../../components/equipSearchTree.vue";
import _ from "loadsh";
import SwiperTool from "@/components/swiperTool.vue";
import { getInstancesDetailId } from "@/service/index";
import EquipmentMaintenance from "@/views/EquipmentMaintenance/Index";
import vueQr from "vue-qr/src/packages/vue-qr.vue";
import Swal from "sweetalert2";
import { API_SVC_HOST, SF_API_PREFIX } from "@/config/common";
import { urlFormat, formatDatetime } from "@/helpers/common";
import axios from "axios";
import Timeline from "@/views/widgets/Timeline";
import ChildListTable from "@/views/equipmentManagement/table.vue";
import examinationReport from "@/views/examination-report";
import EnergyConsumptionAnalysis from "@/views/dashboard/devices/other_page/EnergyConsumptionAnalysis.vue";
// import Pagination from "@/components/common/Pagination.vue";
// import TableLoading from "@/views/widgets/table-loading.vue";
import i18n from "@/i18n";
import moment from "moment/moment";
// import EquipmentDatabase from "@/views/asset/form/equipmentDatabase.vue";
import { SOCKET_SVC_HOST, RULUKA_SVC_HOST,IS_DEMO_PAPER_MAKING_CUSTOMER_ID } from "@/config/common.js";

export default {
  page: {
    title: i18n.global.t("menu.equipment-management.text"),
    meta: [{ tag: 0, name: "description", content: appConfig.description }],
  },
  components: {
    // EquipmentDatabase,
    // TableLoading,
    // Pagination,
    Layout,
    // equipSearchTree,
    SwiperTool,
    EquipmentMaintenance,
    vueQr,
    Timeline,
    ChildListTable,
    examinationReport,
    EnergyConsumptionAnalysis,
  },
  computed: {
    tabsLists(){
      let reslut = this.tabsList
      //造纸厂展示内容
      if(this.isPaperMaking&&this.dataInfo.product_type == 1){//非机组展示
        reslut.map(item=>{
          if(["examinationReport","energyConsumptionAnalysis"].includes(item.href)){
            item.isShow = false
          }
        })
      }
      return reslut;
    },
    //造纸厂展示内容
    isPaperMaking(){
      return this.$store.state.equipManagement.isDemonstrationPaperMaking;
    }, 
    equip_id() {
      return this.$route.query.sub_id || this.$route.query.equip_id;
    },
    ruluka_host() {
      return _.trimEnd(_.trim(RULUKA_SVC_HOST, '"'), "/");
    },
    user() {
      return JSON.parse(localStorage.getItem("user"));
    },
    qrcodeExportUrl() {
      return urlFormat(
        API_SVC_HOST,
        SF_API_PREFIX,
        "/api/instances/export-qrcode"
      );
    },
  },
  data() {
    return {
      map: null, //地图对象
      marker: null, //标记对象
      loaded: false,
      infoWindow: null, //弹窗对象
      upgrade_type: 1,
      is_jigai: false,
      tabActive: "baseInfo",
      tableData: [],
      originData: [],
      singleData: {},
      formType: null,
      isShowForm: false,
      /* 分页 */
      page: 1,
      perPage: 10,
      prePageOption: [10, 15, 20, 25],
      pages: [],
      imagedata_length: 0,
      selectedTheadNum: 0,
      tabsList: [
        {
          title: this.$t("page.basic-info"),
          href: "baseInfo",
          isShow: true,
          permCode: "device.get",
        },
        // { title: "维护保养信息", href: "repairInfo", isShow: true },
        {
          title: this.$t("menu.equipment-management.FullLifeCircle"),
          href: "fullLifecycle",
          isShow: true,
          permCode: "device.get",
        },
        {
          title: this.$t("menu.equipment-management.AssociatedGroupTypeDevice"),
          href: "associatedUnitDevices",
          isShow: false,
          permCode: "device.get",
        },
        {
          title: this.$t(
            "menu.equipment-management.AssociatedIndividualDevice"
          ),
          href: "associatedSingleDevices",
          isShow: true,
          permCode: "device.get",
        },
        {
          title: this.$t("audit_report"),
          href: "examinationReport",
          isShow: true,
          permCode: "device.get",
        },
        {
          title: this.$t("energy_consumption_analysis"),
          href: "energyConsumptionAnalysis",
          isShow: true,
          permCode: "device.get",
        },

        // { title: "配件清单", href: "sparePartsList" },
        // { title: "实时监控", href: "monitor" },
        // { title: "历史曲线", href: "historicalCurve" },
        // { title: "区间统计", href: "intervalStatistics" },
        // { title: "故障与预警", href: "warning" },
        // { title: "节能报告", href: "energy" },
        // { title: "生命周期", href: "lifeCycle" },
      ],
      documentKeywords: "",
      equipmanageInfo: [],
      files: { image: [], video: [], document: [] },
      energy: {
        is_upgrade: false,
        files: {
          actual: [],
          before: [],
          after: [],
        },
      },
      dataInfo: {},
      devicestatus: "unknown", //设备状态
      status: {
        error: this.$t("menu.equipment-management.risk"),
        unknown: this.$t("page.event-management.unknown"),
        "sub-health": this.$t("page.event-management.abnormal"),
        health: this.$t("page.event-management.health"),
      },
      // status: {
      //   error: this.$t("menu.equipment-management.risk"),
      //   unknown: this.$t("page.event-management.unknown"),
      //   "sub-health": this.$t("page.event-management.abnormal"),
      //   health: this.$t("page.event-management.health"),
      // },
      warnStatusList: ["health", "sub-health", "error", "unknown"],
      queryId: "",
      alertInfo: {
        variant: "danger",
        content: this.$t("page.event-management.RequestFailedPleaseTryAgain"),
        icon: "ri-error-warning-line",
      },
      isShowAlert: false,
      timer: null,
      /* 设备列表 */
      equipmentList: [],
      /* 维护项目列表 */
      itemsList: [],
      qrCodeValue: null,
      qrcodeLogo: require("@/assets/images/u11.jpeg"),
      qrcodeOptions: [
        { value: 0, label: this.$t("menu.equipment-management.NotBound") }, //未绑定
        { value: 1, label: this.$t("menu.equipment-management.Bound") }, //已绑定
        { value: 2, label: this.$t("menu.equipment-management.UnabletoBound") }, //无法绑定
      ],
      childListParam: {
        column: [
          {
            dataIndex: "name",
            title: this.$t("page.device_name"),
            isShow: true,
            canView: false,
            permCode: "device.get",
          },
          {
            dataIndex: "设备厂商",
            title: this.$t("page.EquipmentManufacturer"),
            isShow: true,
            canView: false,
            permCode: "device.get",
          },
          {
            dataIndex: "root_sn",
            title: this.$t("page.pump_head_serial_number"),
            isShow: true,
            canView: false,
            permCode: "device.get",
          },
          {
            dataIndex: "group_sn",
            title: this.$t("page.unit_serial_number"),
            isShow: true,
            canView: false,
            permCode: "device.get",
          },
          {
            dataIndex: "所在位置",
            title: this.$t("page.locationOn"),
            isShow: true,
            canView: false,
            permCode: "device.get",
          },
          {
            dataIndex: "发货时间",
            title: this.$t("page.device-attr.delivery_time"),
            isShow: true,
            canView: false,
            permCode: "device.get",
          },
          {
            dataIndex: "客户名称",
            title: this.$t("page.customer_name"),
            isShow: true,
            canView: false,
            permCode: "device.get",
          },
          {
            dataIndex: "应用行业",
            title: this.$t("page.applicationIndustry"),
            isShow: true,
            canView: false,
            permCode: "device.get",
          },
          {
            dataIndex: "维保服务商",
            title: this.$t("page.tending.service_provider"),
            isShow: true,
            canView: false,
            permCode: "device.get",
          },
          {
            dataIndex: "设备状态",
            title: this.$t("page.deviceStatus"),
            isShow: true,
            canView: false,
            permCode: "device.get",
          },
          {
            dataIndex: "is_qrcode_bind",
            title: this.$t("menu.equipment-management.QrcodeBinding"),
            isShow:
              JSON.parse(localStorage.getItem("user")) &&
              JSON.parse(localStorage.getItem("user")).user_type !== "customer",
            canView: false,
            permCode: "device.get",
          },
        ],
        tableData: [],
        tableData1: [],
        actionIcon: [
          {
            textType: "primary",
            iconClass: "ri-pencil-fill",
            type: "edit",
            permCode: "device.put",
          },
          {
            textType: "primary",
            iconClass: "ri-eye-fill",
            type: "view",
            permCode: "device.get",
          },
          {
            textType: "danger",
            iconClass: "ri-delete-bin-5-fill",
            type: "delete",
            permCode: "device.delete",
          },
        ],
      },
      examinationWidth: 0,
      /* 设备详情信息 */
      equip_data: {},
      measurements: [], //允许展示的测点数据
      shadowIdsMeasureStats: {}, //关于所有测点状态
    };
  },
  watch: {
    $route(to, from) {
      console.log(1);
      if (to.query.equip_id != from.query.equip_id) {
        this.queryId = to.query.equip_id; // 把最新id赋值给定义在data中的id
        if (!this.queryId && !this.equip_id) return;
        this.measurements = [];
        this.getInstancesDetail(); // 重新调用加载数据方法
      }
      this.openLatestTab();
    },
    tabActive: {
      immediate: true,
      handler(val) {
        localStorage.setItem("instanceDetailCurrentTab", val);
        let box = document.getElementById("tabBox");
        if (box) this.examinationWidth = box.offsetWidth - 350;
      },
    },
  },
  methods: {
    async initMap(client) {
      await AMapLoader.load({
        key: "d5075185b58a6bb8a0505874ae723f79", // 申请好的Web端开发者Key，首次调用 load 时必填
        plugins: ["AMap.Marker", "AMap.InfoWindow"], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        callback: "onAPILoaded", //回调函数
      });

      this.map = new window.AMap.Map("mapBox", {
        //生成底图在mapContainer这个div里
        center: [client.Longitude, client.Latitude], // 初始中心点坐标
        zoom: 17, // 初始缩放级别
      });

      this.addMarker(client); //添加标记点的方法
    },

    addMarker(client) {
      this.marker = new window.AMap.Marker({
        //新增一个标记点
        position: [client.Longitude, client.Latitude],
        icon: new window.AMap.Icon({
          // image: 'https://vdata.amap.com/icons/b18/1/2.png', // 自定义图标地址
          size: new window.AMap.Size(30, 40), // 图标大小
        }),
      });
      this.marker.setMap(this.map); //放在map这个对象里面
      //顺便新增一个点击标记点出来的窗口
      this.infoWindow = new window.AMap.InfoWindow({
        //新增一个window窗口
        width: 200,
        content: "奥体中心", // 添加你想要显示的文字描述
        offset: new window.AMap.Pixel(0, -30), // 设置信息窗体偏移量，使其显示在标记点正上方
      });

      // 点击标记点时显示信息窗体
      // this.infoWindow.open(this.map, this.marker.getPosition());

      // this.marker.on("click", () => {
      //   this.infoWindow.open(this.map, this.marker.getPosition());
      // });
    },
    /** 回调函数 地图渲染好时触发 不需要可以删掉 */
    onAPILoaded() {
      this.loaded = true;
      console.log("执行对地图的其他操作");
      // 在这里可以执行其他与地图相关的操作
    },

    formatDatetime,
    goBack() {
      const lastRoute = JSON.parse(localStorage.getItem("lastRoute"));
      if (lastRoute.path === "/asset/form") {
        // 如果上一个页面的路由是 /asset/form，跳转到列表页
        this.$router.push({
          path: "/equipment-management",
        });
      } else {
        if (this.$route.query.sub_id) {
          this.$router.push(
            "/VSD420-OverAll?index=" +
              this.$route.query.index +
              "&equip_id=" +
              this.$route.query.equip_id +
              "&sub_id=" +
              this.$route.query.sub_id
          );
        } else {
          // 否则返回上一页
          this.$router.go(-1);
        }
      }
    },
    exportDeviceQRCode() {
      let id = this.queryId || this.equip_id;
      if (!id) return;
      Swal.fire({ title: this.$t("base.exporting"), showConfirmButton: false });
      Swal.showLoading();
      axios
        .post(
          this.qrcodeExportUrl,
          {
            export_id_list: id,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          }
        )
        .then((res) => {
          if (!res.data.payload.request_id) return;
          this.ifHolidayfun(
            this.qrcodeExportUrl + "?request_id=" + res.data.payload.request_id,
            7
          );
        })
        .catch((err) => {
          Swal.close();
          this.handleAlert("danger", err || this.$t("base.file_export_failed"));
        });
    },
    getifHoliday(url) {
      return new Promise((resolve) => {
        //此接口为循环调用的接口，按照自己的需要进行修改
        axios
          .get(url, {
            // responseType: "blob",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
          })
          .then((res) => {
            resolve(res);
          });
      });
    },
    async ifHolidayfun(url) {
      let tmier = null;
      tmier = setInterval(async () => {
        let ifHoliday = await this.getifHoliday(url);
        if (ifHoliday.data.payload.status == "ok") {
          let link = document.createElement("a");
          link.href = ifHoliday.data.payload.url;
          link.download = ifHoliday.data.payload.file_name || "temp.zip";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          Swal.close();
          clearInterval(tmier);
        }
      }, 1000);
    },
    //生成二维码
    setQRcodeUrl(attributes, extra_info) {
      let qrcodeCheckedList = extra_info.qrcodeCheckedList;
      let codes = "";
      attributes.map((attr) => {
        if (
          attr.group === "设备出厂信息" &&
          (!qrcodeCheckedList || qrcodeCheckedList.includes(attr.id))
        ) {
          let unit = attr.unit == this.$t("page.no") ? "" : attr.unit;
          codes += `${attr.name}:${attr.value} ${unit};`;
        }
      });
      this.qrCodeValue = codes;
    },
    filterGroupAttr(arr) {
      var map = {},
        dest = [];
      for (var i = 0; i < arr.length; i++) {
        var ai = arr[i];

        if (
          ai["group"] ==
            this.$t("page.work-order.device.equipment_delivery_information") &&
          ai["name"] == this.$t("page.model")
        ) {
          this.dataInfo.devicenumber = ai["value"];
        }
        if (
          ai["group"] ==
            this.$t("page.work-order.device.device_management_information") &&
          ai["name"] ==
            this.$t("menu.equipment-management.EquipmentAssetCoding")
        ) {
          this.dataInfo.devicecode = ai["value"];
        }

        if (!map[ai.group]) {
          dest.push({
            group: ai.group,
            list: [ai],
          });
          map[ai.group] = ai;
        } else {
          for (var j = 0; j < dest.length; j++) {
            var dj = dest[j];
            if (dj.group == ai.group) {
              dj.list.push(ai);
              break;
            }
          }
        }
      }
      return dest;
    },
    getStatus() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        let equipActive = document.getElementsByClassName("item-active")[0];
        if (equipActive) {
          this.devicestatus = equipActive.firstChild.classList[1];
        }
      }, 500);
    },
    getInstancesDetail() {
      let params = {
        id: this.queryId || this.equip_id,
      };
      getInstancesDetailId(params)
        .then((res) => {
          if (res && res.payload) {
            /* 设备实例详情 */
            this.dataInfo = _.cloneDeep(res.payload);
            this.equip_data = _.cloneDeep(res.payload);
            //造纸厂展示内容
            if (this.dataInfo.customer_id == IS_DEMO_PAPER_MAKING_CUSTOMER_ID) { 
              this.$store.commit( "equipManagement/setIsDemonstrationPaperMaking", true);
            }else{
              this.$store.commit( "equipManagement/setIsDemonstrationPaperMaking", false);
            }
            /* ------获取允许展示测点数据列表--------- */
            let stat = {};
            if (
              this.equip_data.attributes &&
              this.equip_data.attributes.measurements.length
            ) {
              this.equip_data.attributes.measurements.map((item) => {
                if (item.is_show === undefined || item.is_show) {
                  this.measurements.push(item.key);
                  stat[item.key] = -1;
                }
              });
            }
            this.shadowIdsMeasureStats[this.dataInfo.id] = stat;

            if (this.equip_data.children && this.equip_data.children.length) {
              this.measurementsBack(this.equip_data.children);
            }

            // console.log("获取允许展示测点数据列表",this.measurements);
            // console.log("shadowIdsMeasureStats",this.shadowIdsMeasureStats);

            const associatedUnitDevices = this.tabsList.find(
              (item) => item.href === "associatedUnitDevices"
            );
            if (this.dataInfo.product_type == 1) {
              associatedUnitDevices.isShow = true;
            } else {
              associatedUnitDevices.isShow = false;
            }
            let attrData = res.payload.attributes.attributes;
            attrData &&
              attrData.forEach((attr) => {
                if (attr.name === "质保到期时间") {
                  if (
                    (attr.value === "Invalid date" || attr.value === "") &&
                    attrData.filter((item) => {
                      return item.name === "发货时间";
                    }).length > 0
                  ) {
                    attr.value =
                      attrData.filter((item) => {
                        return item.name === "发货时间";
                      })[0].value === "Invalid date" ||
                      attrData.filter((item) => {
                        return item.name === "发货时间";
                      })[0].value === ""
                        ? "无"
                        : moment(
                            attrData.filter((item) => {
                              return item.name === "发货时间";
                            })[0].value
                          )
                            .add(1, "years")
                            .format("YYYY/MM/DD");
                  }
                }
                if (attr.name === "维保服务商" && attr.owner === "inherit") {
                  attr.value = res.payload.service_company_txt || null;
                }
                if (attr.name === "应用行业") {
                  attr.value =
                    (isNaN(attr.value) &&
                      this.$t(
                        `overview_dynamic.industy_dict['${attr.value}']`
                      )) ||
                    "";
                }
              });
            this.setQRcodeUrl(
              res.payload.attributes.attributes,
              res.payload.extra_info
            );
            this.files = _.cloneDeep(res.payload.files);
            this.energy = (res.payload.energy && res.payload.energy) || {
              is_upgrade: false,
              files: {
                actual: [],
                before: [],
                after: [],
              },
            };

            this.equipmanageInfo = this.filterGroupAttr(attrData);

            /* 设备列表 */
            this.equipmentList = res.payload.children;
            /* 维护项目列表 */
            this.itemsList = res.payload.repairs;
            // if (!this.timer)
            //   setTimeout(() => {
            //     let equipActive =
            //       document.getElementsByClassName("item-active")[0];
            //     if (equipActive) {
            //       this.devicestatus = equipActive.firstChild.classList[1];
            //     }
            //   }, 1000);
            /* 关联单体设备 */
            this.childListParam.tableData = [];
            const list = [];
            this.getEquipmentArr(res.payload.children).map((item) => {
              list.push(item);
            });
            this.setEquipmentList({ list, type: "children" });
            /* 关联机组设备 */
            this.childListParam.tableData1 = [];
            if (
              res.payload.relation_group &&
              Object.keys(res.payload.relation_group).length > 0
            ) {
              const list1 = [res.payload.relation_group];
              this.setEquipmentList({ list: list1, type: "relation_group" });
            }
            let deviceTokenList = this.equipmanageInfo.filter((item) => {
              return item.group === "设备出厂信息";
            })[0].list;
            let deviceToken = null;

            deviceTokenList.map((item) => {
              if (item.name === "DeviceToken") {
                deviceToken = item.value;
              }
            });
            if (deviceToken) {
              let config = {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem(
                    "accessToken"
                  )}`,
                },
                withCredentials: true,
              };
              axios
                .get(
                  this.ruluka_host +
                    "/api/v1/" +
                    deviceToken +
                    "/attributes?clientKeys=Latitude,Longitude",
                  config
                )
                .then((ress) => {
                  console.log(ress.data.client, deviceToken);
                  AMapLoader.reset(); //在加载地图前加一个reset方法 解决报错
                  this.initMap(ress.data.client); //加载地图
                });
            }
          }
        })
        .catch((err) => {
          console.log(err);
          this.handleAlert(
            "danger",
            this.$t(
              "menu.equipment-management.FailedToObtainDeviceDetailsPleaseTryAgain"
            )
          );
        });
    },
    //递归获取设备可展示测点列表
    measurementsBack(children) {
      children.map((equip) => {
        let stat = {};
        if (
          equip.product_type == 1 &&
          equip.attributes &&
          equip.attributes.measurements.length
        ) {
          //设备
          equip.attributes.measurements.map((item) => {
            if (item.is_show === undefined || item.is_show) {
              this.measurements.push(item.key);
              stat[item.key] = -1;
            }
          });
        }
        this.shadowIdsMeasureStats[equip.id] = stat;
      });
    },
    getEquipmentArr(data) {
      let result = [];
      let queue = data;
      while (queue.length > 0) {
        [...queue].forEach((child) => {
          queue.shift();
          result.push(child);
          child.children && queue.push(...child.children);
        });
      }
      return result;
    },
    setEquipmentList({ list, type }) {
      let infoList = [];
      list.forEach((item) => {
        let info = {
          id: item.id,
          name: item.name,
          root_sn: item.root_sn,
          group_sn: item.group_sn,
          has_parent: item.has_parent,
          has_children: item.has_children,
          parent_id: item.parent_id,
          is_qrcode_bind: item.is_qrcode_bind,
          root_sn_list: item.root_sn_list || [],
        };
        if (item.attributes.attributes) {
          item.attributes.attributes.forEach((attr) => {
            // if (attr.group == "设备出厂信息" || attr.group == "设备管理信息")
            info[attr.name] = attr.value;
          });
        }
        infoList.push(info);
      });
      if (type === "children") {
        this.childListParam.tableData = infoList;
      } else {
        this.childListParam.tableData1 = infoList;
      }
    },
    getAssociatedDevices() {
      let params = {
        id: this.queryId || this.equip_id,
      };
      getInstancesDetailId(params)
        .then((res) => {
          if (res && res.payload) {
            /* 关联单体设备 */
            const list = [];
            this.getEquipmentArr(res.payload.children).map((item) => {
              list.push(item);
              this.setEquipmentList({ list, type: "children" });
            });
            /* 关联机组设备 */
            const list1 = [];
            this.getEquipmentArr(res.payload.relation_group ?? []).map(
              (item) => {
                list1.push(item);
                this.setEquipmentList({ list1, type: "relation_group" });
              }
            );
          }
        })
        .catch(() => {
          this.handleAlert(
            "danger",
            this.$t(
              "menu.equipment-management.FailedToObtainDeviceDetailsPleaseTryAgain"
            )
          );
        });
    },
    handleSearch(e) {
      if (e.keyCode == 13) {
        e.cancelBubble = true;
        e.stopPropagation();
        e.preventDefault();

        if (!this.dataInfo.files.document.length) return;

        if (this.documentKeywords) {
          this.files.document = this.dataInfo.files.document.filter((item) => {
            return item.object_name
              .replace(/\s*/g, "")
              .toUpperCase()
              .includes(
                this.documentKeywords.replace(/\s*/g, "").toUpperCase()
              );
          });
        } else {
          this.files.document = this.dataInfo.files.document;
        }
      }
    },
    handleAlert(
      variant = "danger",
      message = "",
      icon = "ri-error-warning-line",
      duration = "3000"
    ) {
      this.isShowAlert = true;
      this.alertInfo.variant = variant;
      this.alertInfo.icon = icon;
      if (message) {
        this.alertInfo.content = message;
      }
      setTimeout(() => {
        this.isShowAlert = false;
      }, duration);
    },
    clearTimer() {
      clearInterval(this.timer);
      this.timer = null;
    },
    // 打开最近一次的tab
    openLatestTab() {
      let tabHistory = localStorage.getItem("instanceDetailTabHistory");
      if (tabHistory) {
        let tabHistoryArr = JSON.parse(tabHistory);
        let lastTab = tabHistoryArr.pop();
        this.tabActive = lastTab;
        localStorage.setItem(
          "instanceDetailTabHistory",
          JSON.stringify(tabHistoryArr)
        );
      }
    },
    /* 获取推送数据,处理 */
    initWebSocket() {
      const interval = setInterval(() => {
        if (this.retryCount > 10) {
          clearInterval(interval);
          this.retryCount = 0;
          return;
        }
        const stompClient = this.$websocket.getters.stompClient();
        if (stompClient != null && stompClient.connected) {
          clearInterval(interval);
          stompClient.subscribe("/topic/stream", (msg) => {
            if (msg && msg.body) {
              let websocketdata = Array.isArray(JSON.parse(msg.body))
                ? JSON.parse(msg.body)
                : [JSON.parse(msg.body)];
              if (this.$route.path == "/equipment-detail") {
                this.getWebsocket(websocketdata);
              }
            }
          });
        } else {
          if (!localStorage.getItem("accessToken")) return;
          const _url =
            SOCKET_SVC_HOST +
            "/messaging/stomp?access_token=" +
            localStorage.getItem("accessToken");
          this.$websocket.dispatch("WEBSOCKET_INIT", _url);
        }
        this.retryCount++;
      }, 1000);
    },
    /* 处理数据匹配对应设备id 判断数状态 */
    getWebsocket(socdata) {
      if (socdata && socdata.length) {
        let onesocdata = socdata[0];
        if (
          this.shadowIdsMeasureStats[onesocdata.shadowId] &&
          onesocdata.report
        ) {
          onesocdata.report.map((item) => {
            if (
              this.shadowIdsMeasureStats[onesocdata.shadowId][item.id] !==
                undefined &&
              this.shadowIdsMeasureStats[onesocdata.shadowId][item.id] !== null
            ) {
              this.shadowIdsMeasureStats[onesocdata.shadowId][item.id] =
                item.stat;
            }
          });
        }
        // socdata.map(soc => {
        // if(this.dataInfo.product_type == "1" &&this.$route.query.equip_id ==  soc.shadowId ){ //单体设备
        if (this.dataInfo.product_type == "1") {
          //单体设备

          this.devicestatus = this.getTopStatusCopy(this.dataInfo.id);

          this.getChildrenStatus(this.dataInfo.children); // 防止单体设备有关联单体设备
        } else if (this.dataInfo.product_type == "2") {
          //机组设备
          this.getChildrenStatus(this.dataInfo.children);
        }

        // })

        this.dataInfo.children &&
          this.dataInfo.children.map((instance) => {
            if (instance.product_type == "1") {
              this.devicestatus = instance.stat;
            }
          });
        // console.log('this.dataInfo',this.dataInfo);
      }
    },
    /* 大于0的状态赋值给初始值为0健康状态，大于0的状态。异常1，危险2。进行赋值 */
    getTopStatus(data) {
      let status = "-1",
        status_list = {
          //设备状态
          "-1": "unknown",
          0: "health",
          1: "sub-health",
          2: "error",
        };
      if (data && data.length > 0) {
        data.map((item) => {
          if (this.measurements.includes(item.id)) {
            if (
              item.stat !== undefined &&
              item.stat !== null &&
              item.stat > status
            ) {
              status = item.stat;
            }
          }
        });
      }
      return status_list[status];
    },
    getTopStatusCopy(id) {
      let status = "-1",
        status_list = {
          //设备状态
          "-1": "unknown",
          0: "health",
          1: "sub-health",
          2: "error",
        };
      if (this.shadowIdsMeasureStats[id]) {
        let values = Object.values(this.shadowIdsMeasureStats[id]);
        if (values) {
          status = Math.max(...values);
        }
      }
      return status_list[status];
    },
    /* 子设备状态赋值 */
    getChildrenStatus(children, soc) {
      if (children && children.length > 0) {
        children.map((item) => {
          // if (item.id == soc.shadowId) {
          item.stat = this.getTopStatusCopy(item.id);
          // }
        });
      }
    },
  },
  created() {
    this.getInstancesDetail();
  },
  mounted() {
    // this.getStatus();

    this.openLatestTab();
    if (this.$route.query.type) {
      this.tabActive = this.$route.query.type;
    }
    //获取实时推送数据，获取设备状态
    this.initWebSocket();
  },
  beforeUnmount() {
    this.clearTimer();
  },
};
</script>
<style lang="scss" scoped>
.box-pend {
  padding: 1rem 1rem 3rem;
}
.center-ads-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  .li {
    flex: 1;
    margin: 0 20px 15px 0;
    width: calc((100% - 60px) / 4);
    min-width: calc((100% - 60px) / 4);
    max-width: calc((100% - 60px) / 4);

    &:nth-child(4n + 4) {
      margin-right: 0;
    }
  }
}

.noimage {
  background-image: url("../../assets/images/no-images-bg.png");
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.btn-export {
  font-size: 12px;
  padding: 2px;
  width: 100%;
  margin-top: 6px;
}
</style>
